import { render, staticRenderFns } from "./addData.vue?vue&type=template&id=4664cd6b&scoped=true&"
import script from "./addData.vue?vue&type=script&lang=js&"
export * from "./addData.vue?vue&type=script&lang=js&"
import style0 from "./addData.vue?vue&type=style&index=0&id=4664cd6b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4664cd6b",
  null
  
)

export default component.exports